class PushItemModel {

    constructor(model) {
        this.model = model
    }

    get gmtModify() {
        return placeholderText(this.model.gmtModify)
    }

    get gmtCreate() {
        return placeholderText(this.model.gmtCreate)
    }

    get pushStatus() {
        return PUSH_LOG_STATUS_TYPE.find(el => el.value === this.model.pushStatus)?.label
    }

    get pushContent() {
        return placeholderText(this.model.pushContent)
    }

    get hospitalName() {
        return placeholderText(this.model.hospitalName)
    }

    get pushMethod() {
        if (this.model.pushMethod == 1) {
            return "微信"
        } else if (this.model.pushMethod == 2) {
            return "短信"
        } else { 
            return '-'
        }
    }

    get targetType() {
        if (this.model.targetType == 1) {
            return "机构"
        } else if (this.model.targetType == 2) {
            return "用户"
        } else {
            return '-'
        }
    }

    get pushType() {
        if (this.model.pushType == 1) {
            return "睡眠报告"
        } else if (this.model.pushType == 2) {
            return "患者绑定设备信息成功"
        } else if (this.model.pushType == 3) {
            return "监测设备开启成功"
        } else if (this.model.pushType == 4) {
            return "异常原因推送"
        } else if (this.model.pushType == 5) {
            return "重启提示"
        } else {
            return '-'
        }
    }
}

export { PushItemModel }